import {PersistentTrigger, TimeWindowCondition, type TriggerCondition, type TriggerFactory} from "./triggers";
import {Timer, TimerConfig, TimerFactory} from "../../page/elements/timer";
import {autoRegister, resolve} from "../../container";
import {isPresent} from "../utils/basics";
import type {Nullable} from "../../bootstrap/common/types";

export class TimerTrigger extends PersistentTrigger {
    private timer: Timer;

    public constructor(
        protected element: Element,
        private timerFactory: TimerFactory,
        triggerConditions: TriggerCondition[],
        callback: () => void
    ) {
        super(triggerConditions, callback);
        const triggerDelay = milliseconds(element.getAttribute("data-trigger-delay")) ?? 500;

        const timerConfig = new TimerConfig()
            .withDelay(triggerDelay)
            .withCallback(() => this.trigger());
        this.timer = this.timerFactory.newTimer(timerConfig);
    }

    public stop(): void {
        super.stop();
        this.timer.stop();
    }
}

const milliseconds = (seconds: Nullable<string>): Nullable<number> => {
    const parsed = seconds?.toFloat();
    return isPresent(parsed) ? parsed * 1000 : null;
};

@autoRegister()
export class TimerTriggerFactory implements TriggerFactory {
    public constructor(private timerFactory: TimerFactory = resolve(TimerFactory)) {
    }

    public createTrigger(element: Element, callback: () => void): TimerTrigger {
        return new TimerTrigger(element, this.timerFactory, TimeWindowCondition.timeWindowCondition(element), callback);
    }
}